{
  "coursera-title": "Coursera",
  "coursera-description": "Coursera is a world-wide online learning platform founded in 2012 by Stanford computer science professors Andrew Ng and Daphne Koller that offers massive open online courses, specializations, and degrees.",
  "In use": "In use",
  "Licenses": "Licenses",
  "Total": "Total",
  "E-mail address": "Email address",
  "License Status": "License Status",
  "Filter by Status": "Filter by Status",
  "All Statuses": "Choose",
  "Invited": "Invited",
  "Joined": "Joined",
  "Cancelled": "Cancelled",
  "User Id": "User Id",
  "email": "Email",
  "enrollment-status": "Status",
  "revoke": "Revoke",
  "approve": "Approve",
  "approved": "Approved",
  "pending-approval": "Pending Approval",
  "revoked"  : "Revoked"
}
